import { DirCategory } from '@src/components/sco/Advisors/types'
import {
  LuAward,
  LuBriefcase,
  LuCircleDollarSign,
  LuLayoutGrid,
  LuScale,
  LuStar,
  LuTarget,
  LuTrendingUp,
  LuUsers,
} from 'react-icons/lu'

export const DIR_CATEGORIES: DirCategory[] = [
  {
    key: 'funding',
    name: 'Funding',
    palette: 'green',
    icon: LuTrendingUp,
    value: 'Get in front of the right investors and nail your raise.',
    chips: ['Pitch & deck', 'Investor intros', 'Valuation', 'Angel & seed'],
  },
  {
    key: 'customer-acquisition',
    name: 'Customer acquisition',
    palette: 'orange',
    icon: LuTarget,
    value: 'Find your first customers and a repeatable growth engine.',
    chips: ['Go-to-market', 'Paid acquisition', 'Sales', 'Retention'],
  },
  {
    key: 'product',
    name: 'Product',
    palette: 'purple',
    icon: LuLayoutGrid,
    value: 'Sharpen what you build and how users adopt it.',
    chips: ['Strategy', 'Roadmap', 'UX & design', 'Activation'],
  },
  {
    key: 'engineering-tech',
    name: 'Engineering & Tech',
    palette: 'blue',
    icon: LuBriefcase,
    value: 'Architect, secure, and scale your technology.',
    chips: ['Architecture', 'Security', 'DevOps', 'Data'],
  },
  {
    key: 'team-hiring',
    name: 'Team & Hiring',
    palette: 'pink',
    icon: LuUsers,
    value: 'Recruit, structure, and lead a team that performs.',
    chips: ['Recruiting', 'Comp & equity', 'Org design', 'Culture'],
  },
  {
    key: 'ops-finance',
    name: 'Operations & Finance',
    palette: 'yellow',
    icon: LuCircleDollarSign,
    value: 'Run clean books, models, and the legal foundation.',
    chips: ['Financial modeling', 'Cap table', 'Unit economics', 'Tax'],
  },
  {
    key: 'legal',
    name: 'Legal',
    palette: 'blue',
    icon: LuScale,
    value: 'Navigate formation, contracts, IP, and compliance without expensive surprises.',
    chips: ['Formation', 'Contracts', 'IP', 'Employment'],
  },
  {
    key: 'design-brand',
    name: 'Design & Brand',
    palette: 'teal',
    icon: LuStar,
    value: 'Shape how your product looks, feels, and gets remembered.',
    chips: ['Brand identity', 'Visual design', 'UX & UI', 'Design systems'],
  },
  {
    key: 'leadership',
    name: 'Leadership & Strategy',
    palette: 'purple',
    icon: LuAward,
    value: "Make the big calls with people who've been there.",
    chips: ['Founder coaching', 'Board', 'Scaling', 'M&A'],
  },
]

export const CATEGORY_PALETTE_BY_KEY: Record<string, string> = Object.fromEntries(
  DIR_CATEGORIES.map(cat => [cat.key, cat.palette])
)
